<div *ngIf="sectionId && sectionType != undefined">
    <incourse-navigation #inCourseNavigation [theme]="theme" [navigationData]="localNavigationData" [currentSectionId]="currentSectionId"></incourse-navigation>
    <div *ngIf="sectionType == -1">
        
    </div>
    <div *ngIf="sectionType == 0">
        <intro #introSection></intro>
    </div>
    <div *ngIf="sectionType == 1">
        <topic #topicSection></topic>
    </div>
    <div *ngIf="sectionType == 3">
        <overview #overviewSection></overview>
    </div>
    <div *ngIf="sectionType == 2">
        <peb-topic #pebSection></peb-topic>
    </div>
    <div *ngIf="sectionType == 4">
        <conclusion #conclusionSection></conclusion>
    </div>
    <div *ngIf="sectionType == 5">
        <soi-section #soiSection></soi-section>
    </div>
    <navigation-progress #navigationProgress [sectionsTotal]="sectionsTotal" [currentSection]="currentSection" [theme]="theme" [sectionType]="sectionType"></navigation-progress>
</div>